import axios from "axios";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";


const Login = () => {
    document.title = "DirtMap - Login";

    const history = useHistory();
    const [loginInput, setLogin] = useState({
        email: '',
        password: '',
        error_list: [],
    });
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    const [showPassword, setShowPassword] = useState(false);

    const handleInput = (e) => {
        e.persist();
        setLogin({ ...loginInput, [e.target.name]: e.target.value });
    }

    const loginSubmit = async (e) => {
        e.preventDefault();
        const data = {
            email: loginInput.email,
            password: loginInput.password
        }
        showLoader();
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post('/api/user/login', data).then(res => {
                

                if (res.data.result) {
                    localStorage.setItem('auth_token', res.data.result);
                    localStorage.setItem('auth_name', res.data.user_name);
                    localStorage.setItem('user_id', res.data.user_id);     
                    localStorage.setItem('type', res.data.user_type);                //  swal("success", res.data.message, "success");
                    hideLoader();
                    swal({ position: 'top-end', icon: 'success', title: res.data.message, showConfirmButton: false, timer: 1500 });

                    // Redirect renew-site
                    const renewToken = localStorage.getItem("renew_token");
                    if (renewToken) {
                        history.push(`/renew-site?token=${renewToken}`);
                        return;
                    }

                    // Redirect renew-user
                    const renewUserToken = localStorage.getItem("renew_user_token");
                    if (renewUserToken) {
                        history.push(`/renew-account?token=${renewUserToken}`);
                        return;
                    }

                    if (res.data.user_role === 'admin') {
                        console.log(res.data.user_role);
                        hideLoader();
                        history.push('/admin/dashboard');

                    } else {
                        hideLoader();
                        console.log(res.data.user_role);
                        history.push('/');
                    }

                }
                else {
                    if (res.data.errors) {
                        hideLoader();
                        swal({ title: "Error!", text: res.data.message, type: "Error", icon: 'error', confirmButtonText: 'Cool' });
                        setLogin({ ...loginInput, error_list: res.data.errors });
                    } else {
                        hideLoader();
                        //swal("Error", res.data.message, "Error");
                        swal({
                            title: "Error!",
                            text: res.data.message,
                            type: "Error",
                            icon: 'error',
                            confirmButtonText: 'Cool'
                        });
                        history.push('/login');

                    }
                }
            }).catch(error => {
                console.log(error)
            });
        });
    }



    return (
        <section className="contentContainer02 registerBlock">
            <div className="container">
                <div className="shadowBox contactForm pb-5">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="largeSideThumb text-center">
                                <img src={'./frontend/images/register-left-thumb.jpg'} alt=""
                                    className="imgResponsive" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <form onSubmit={loginSubmit}>
                                <h2 className="mt-3 mb-3">Log Into Your Account</h2>
                                <div className="customFormRow">
                                    <div className="inputField inputFieldLogin">
                                        <input type="email" 
                                        name="email" 
                                        onChange={handleInput} 
                                        value={loginInput.email} 
                                        placeholder="Enter Your Email" 
                                        style={{ paddingRight: "120px" }}
                                        />
                                        <span className="validate-error-message">{loginInput.error_list ? loginInput.error_list.email : ''}</span>

                                    </div>
                                </div>
                                <div className="customFormRow">
                                    <div className="inputField inputFieldLogin position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            onChange={handleInput}
                                            value={loginInput.password}
                                            placeholder="Enter Your Password"
                                            autoComplete="current-password"
                                            required
                                            style={{ paddingRight: "120px" }}
                                        />

                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            aria-label={showPassword ? "Hide password" : "Show password"}
                                            style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                border: "none",
                                                background: "transparent",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                padding: "5px",
                                                zIndex: 2
                                            }}
                                        >
                                            {showPassword ? "🙈" : "👁️"}
                                        </button>

                                        <span className="validate-error-message">
                                            {loginInput.error_list.password || ""}
                                        </span>
                                    </div>
                                </div>
                                <div className="customFormRow">
                                    <Link className="forget-password" to="/forget-password">Forgot Password</Link>
                                </div>
                                <div className="customFormRow">
                                    <div className="inputField">
                                        <button type="submit" className="button customButton01 login-btn active submitButton">Login</button>
                                    </div>
                                </div>
                            </form>
                            <div className="customFormRow">
                                <div className="inputField">
                                    <Link to="/register" className="sign-here-link">New User? Create Account</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loader}
        </section>
    )
}
export default Login;